import { focusElementById } from './focusElement';
function handleSkipLinkClick(event) {
    if (!(event.target instanceof Element)) {
        return;
    }
    const link = event.target.closest('a.skip-link[href^="#"]');
    if (!link) {
        return;
    }
    const hash = link.getAttribute('href');
    if (!hash || hash.length < 2) {
        return;
    }
    const id = hash.slice(1);
    if (focusElementById(id)) {
        event.preventDefault();
    }
}
/** Moves focus to skip-link targets when present in the document (SSR markup). */
export function initSkipLinks() {
    document.removeEventListener('click', handleSkipLinkClick);
    document.addEventListener('click', handleSkipLinkClick);
}
